import React from "react";
import MultiInputField from "../../FormFields/MultiInputField";

const A14input = (props) => {
  return <MultiInputField {...props} />;
};

export default A14input;
